'use strict';

import 'moment';
import Loader from '../loader/loader';
import { isFieldEmpty, isDobEmpty, isValidEmail, displayErrors, isValidDob, autofocusDob, initiateAutoCompleteSuburb} from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class UpdateClientDetails {
    constructor() {
        let $body = $('body'),
            $updateClientDetailsDropdown = $('.update-client-details__dropdown'),
            $title = $('#UpdateClientTitle'),
            $firstName = $('#UpdateClientFirstName'),
            $lastName = $('#UpdateClientLastName'),
            $dobDay = $('#DobDay'),
            $dobMonth = $('#DobMonth'),
            $dobYear = $('#DobYear'),
            $gender = $('#UpdateClientGender'),
            $doNotCall = $('#IsDoNotCallOpted'),
            $primaryNumber = $('#UpdateClientPrimaryNumber'),
            $secondaryNumber = $('#UpdateClientSecondaryNumber'),
            $emailAddress = $('#UpdateClientEmailAddress'),
            $addressLine1 = $('#street_number'),
            $addressLine2 = $('#route'),
            $addressSuburb = $('#locality'),
            $suburbStatePostcode = $('#SuburbStatePostcode'),
            $addressPostCode = $('#postal_code'),
            $addressState = $('#administrative_area_level_1'),
            $addressAdditionalNotes = $('#AdditionalAddressNotes'),
            $clientId = $('#ClientId'),
            $clientUr = $('#UpdateClientUrNumber'),
            $updateForm = $('#update-client-form'),
            loader = new Loader(),
            dateCheck,
            _isInvalid = [],
            dataParams = {},
            $ndisEligibility = $('#NDISEligibility'),
            $noEmail = $('#IsDoNotEmail'),
            $noSMS = $('#IsDoNotSMS'),
            $optoutDeceased = $('#IsMasterOptOutDeceased');

        $('.js-expand-client-details').on('click', function (e) {
            e.preventDefault();


            $updateClientDetailsDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
        });
		
		//autofocus on DOB inputs
		autofocusDob();

        $(document).ready(function(){
            initiateAutoCompleteSuburb($suburbStatePostcode, $addressSuburb, $addressPostCode, $addressState);
        });

        $('.js-update-client-details').on('click', function (e) {
            e.preventDefault();

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');
			
			var phoneRegEx = /^[0-9]{8,10}$/;

            _isInvalid = [];

            if ($title.val() == '') {
                $title
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($firstName)) {
                $firstName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($lastName)) {
                $lastName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            
            if (isValidDob()){
                $dobDay.parent().removeClass('incomplete');
                $dobMonth.parent().removeClass('incomplete');
                $dobYear.parent().removeClass('incomplete');

                $('.dob .error').fadeOut({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            }else{
                $dobDay.parent().addClass('incomplete');
                $dobMonth.parent().addClass('incomplete');
                $dobYear.parent().addClass('incomplete');

                $('.dob .error').fadeIn({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if ($gender.val() == '') {
                $gender
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($primaryNumber) || !$primaryNumber.val().match(phoneRegEx)) {
                $primaryNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }
			
			if (!isFieldEmpty($secondaryNumber) && !$secondaryNumber.val().match(phoneRegEx)) {
                $secondaryNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);				
			} 
			
            if($clientUr.data('is-required') == true && $clientUr.val() == ''){
                $clientUr
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0); 
            }

			if (!isValidEmail($emailAddress.val()) && !isFieldEmpty($emailAddress)){
                $emailAddress
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($ndisEligibility)) {
                $ndisEligibility
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($addressLine1)) {
                $addressLine1
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($suburbStatePostcode)) {
                $suburbStatePostcode
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            // if (isFieldEmpty($addressPostCode)) {
            //     $addressPostCode
            //         .parent().addClass('incomplete')
            //         .find('.error').slideDown({
            //             duration: 500,
            //             easing: 'easeOutExpo',
            //             queue: false
            //         });

            //     _isInvalid.push(0);
            // }

            // if (isFieldEmpty($addressSuburb)) {
            //     $addressSuburb
            //         .parent().addClass('incomplete')
            //         .find('.error').slideDown({
            //             duration: 500,
            //             easing: 'easeOutExpo',
            //             queue: false
            //         });

            //     _isInvalid.push(0);
            // }

            // if (isFieldEmpty($addressState)) {
            //     $addressState
            //         .parent().addClass('incomplete')
            //         .find('.error').slideDown({
            //             duration: 500,
            //             easing: 'easeOutExpo',
            //             queue: false
            //         });

            //     _isInvalid.push(0);
            // }

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                $(this).removeClass('error');
                loader.fadeIn();

                dataParams = {
                    'ClientId': $clientId.val(),
                    'Details': {
                        'Title' : $title.val(),
                        'FirstName': $firstName.val(),
                        'LastName': $lastName.val(),
                        'Dob' : {
                            'Day' : $dobDay.val(),
                            'Month' : $dobMonth.val(),
                            'Year' : $dobYear.val()
                        },
                        'Gender': $gender.val(),
                        'PrimaryPhoneNumber': $primaryNumber.val(),
                        'SecondaryPhoneNumber': $secondaryNumber.val() == '' ? null : $secondaryNumber.val(),
                        'EmailAddress': $emailAddress.val() == '' ? null : $emailAddress.val(),
                        'ClientUr': $clientUr.val(),
                        'NDISEligibility': $ndisEligibility.val()
                    },
                    'Address': {
                        "Address1" : $addressLine1.val(),
                        "Address2" : $addressLine2.val(),
                        "Postcode" : $addressPostCode.val(),
                        "Suburb" : $addressSuburb.val(),
                        "State" : $addressState.val(),
                        "AdditionalNote": isFieldEmpty($addressAdditionalNotes) ? null : $addressAdditionalNotes.val()
                    },
                    'IsDoNotCallOpted': $doNotCall.prop('checked'),
                    'IsNoSMSOpted': $noSMS.prop('checked'),
                    'IsNoEmailOpted': $noEmail.prop('checked'),
                    'IsDeceased': $optoutDeceased.prop('checked')
                };

                $.ajax({
                    url: '/api/clients/clientdetails',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'PUT',
                    headers: { __RequestVerificationToken: $updateForm.find('input[name=__RequestVerificationToken]').val() },
                    data: JSON.stringify(dataParams),
                    success: function (data) {
                        toaster('Patient details have been saved!');
                        window.location.href = data.href;
                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        $('.js-collapse-client-details').trigger('click');
                    },
                    error: function (error) {

                        loader.fadeOut();
                        displayErrors(error, $errorContainer );
                    }
                });
            }

        });

    }

}
